import { Box, Modal, TablePagination } from "@mui/material"
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';
import { useState } from "react";
import ReceiptIcon from '@mui/icons-material/Receipt';
import apiSafibc from "../../axios/axios";
import { Flip, ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { toast_config } from "../../toastify/config";
import { useLoginStore } from "../../store/zustend";
import Swal from "sweetalert2";
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';

const styleCi = {
    position: 'absolute',
    top: '10%',
    left: '50%',
    transform: 'translateX(-50%)',
    bgcolor: 'background.paper',
    boxShadow: 24,
    borderRadius: '5px',
    width: '75%',
    maxHeight: '80vh', // Limita altura al 80% de la pantalla
    overflowY: 'auto', // Scroll vertical si se excede
};

const styleRend = {
    position: 'absolute',
    top: '25%',
    left: '50%',
    transform: 'translateX(-50%)',
    bgcolor: 'background.paper',
    boxShadow: 24,
    borderRadius: '5px',
    width: '50%',
    maxHeight: '80vh', // Limita altura al 80% de la pantalla
    overflowY: 'auto', // Scroll vertical si se excede
};

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: theme.palette.common.black,
        color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));



const ModalContratosProximos = ({ open, onClose, contratos }) => {

    const { loginStore } = useLoginStore()

    const [page, setPage] = useState(0); // página actual
    const [rowsPerPage, setRowsPerPage] = useState(10); // registros por página
    const [openPagar, setOpenPagar] = useState(false)
    const [sumaAhorro, setSumaAhorro] = useState(0)
    const [rendimientoAhorro, setRendimientoAhorro] = useState(0)
    const [ahorroRendimientoTotal, setAhorroRendimientoTotal] = useState(0)

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0); // regresar a la primera página
    };

    const contratoPagado = (id_contrato, nombre_ahorrador, id_ahorrador) => {
        
        onClose(true)
        Swal.fire({
            title: `Quieres cambiar contrato a pagado de ${nombre_ahorrador}?`,
            text: "El contrato se cambiara a pagado completo!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Si, Cambiar!"
        }).then((result) => {
            if (result.isConfirmed) {
                const estatusPagado = async () => {

                    try {
                        const jContratoPagado = {
                            id_contrato,
                            id_ahorrador,
                            id_usr_registro: loginStore.jtoken.id_usuario
                        }

                        const contratoPagado = await apiSafibc.post('/navegacion/contrato-pagado', jContratoPagado, {
                            headers: {
                                'Authorization': `Bearer ${loginStore.token}`,
                                'Accept': 'application/x-www-form-urlencoded',
                                'Content-Type': 'application/x-www-form-urlencoded',
                            }
                        })

                        toast.success(contratoPagado.data.mensaje, toast_config)


                    } catch (error) {
                        let msg_error = ''
                        if (error.response) {
                            if (error.response.data.mensaje) {
                                msg_error = error.response.data.mensaje
                            } else {
                                msg_error = 'Ocurrió un error al cambiar estatus de contrato a pagado y generar carta conformidad!'
                            }
                        }
                        //mensaje de toastify
                        toast.error(msg_error, toast_config)
                    }

                }

                estatusPagado()
            }
        });


    }

    const cantidadPagar = (id_contrato) => {

        const buscarCantidadPagar = async () => {

            try {

                const totalPagar = await apiSafibc.get(`/navegacion/rendimiento-total-contrato/${id_contrato}`, {
                    headers: {
                        'Authorization': `Bearer ${loginStore.token}`,
                        'Accept': 'application/x-www-form-urlencoded',
                        'Content-Type': 'application/x-www-form-urlencoded',
                    }
                })

                setSumaAhorro(totalPagar.data.suma_ahorro)
                setRendimientoAhorro(totalPagar.data.rendimiento)
                setAhorroRendimientoTotal(totalPagar.data.ahorroFormatoTotal)

            } catch (error) {
                let msg_error = ''
                if (error.response) {
                    if (error.response.data.mensaje) {
                        msg_error = error.response.data.mensaje
                    } else {
                        msg_error = 'Ocurrió un error al buscar ahorro y rendimiento!'
                    }
                }
                //mensaje de toastify
                toast.error(msg_error, toast_config)
            }


        }

        buscarCantidadPagar()
        setOpenPagar(true)
    }

    const formatFecha = (value) => {

        const fecha = new Date(value + ' 08:00:00')
        const meses = ['ENERO', 'FEBRERO', 'MARZO', 'ABRIL', 'MAYO', 'JUNIO', 'JULIO', 'AGOSTO', 'SEPTIEMBRE', 'OCTUBRE', 'NOVIEMBRE', 'DICIEMBRE']

        return `${fecha.getDate().toString().padStart('2', '0')} DE ${meses[fecha.getMonth()]} DE ${fecha.getFullYear()}`

    }

    return (
        <>
            <Modal
                open={open} onClose={onClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={styleCi}>
                    <div className='nav-header2 pt-4'></div>
                    <div className='card'>
                        <div className='card-header text-center'>
                            <h3>Contratos Proximos a Vencer</h3>
                        </div>
                        <div className='card-body'>
                            {/** AGREGAR UNA TRABLA INDEXADA CON LOS CONTRATOS PROXIMOS */}
                            <TableContainer component={Paper}>
                                <Table sx={{ minWidth: 700 }} aria-label="customized table" className="animation-layout">
                                    <TableHead>
                                        <TableRow>
                                            <StyledTableCell>Último pago</StyledTableCell>
                                            <StyledTableCell>Pagar más tardar</StyledTableCell>
                                            <StyledTableCell align="center">Nombre</StyledTableCell>
                                            <StyledTableCell align="center">Cantidad</StyledTableCell>
                                            <StyledTableCell align="center"></StyledTableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {contratos && contratos
                                            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                            .map((c, i) => (
                                                <StyledTableRow key={i}>
                                                    <StyledTableCell component="th" scope="row">
                                                        {formatFecha(c.fecha_pago.split('T')[0])}
                                                    </StyledTableCell>
                                                    <StyledTableCell component="th" scope="row">
                                                        {formatFecha(c.fecha_vencimiento.split('T')[0])}
                                                    </StyledTableCell>
                                                    <StyledTableCell align="center">{c.nombre_completo}</StyledTableCell>
                                                    <StyledTableCell align="center">
                                                        <VisibilityOutlinedIcon style={{ 'cursor': 'pointer' }} onClick={() => cantidadPagar(c.id_contrato)} />
                                                    </StyledTableCell>
                                                    
                                                    <StyledTableCell align="center">
                                                        <ReceiptIcon style={{ 'cursor': 'pointer' }} onClick={() => contratoPagado(c.id_contrato, c.nombre_completo, c.id_ahorrador)} />
                                                    </StyledTableCell>
                                                    

                                                </StyledTableRow>
                                            ))}
                                    </TableBody>
                                </Table>
                                <TablePagination
                                    component="div"
                                    count={contratos.length}
                                    page={page}
                                    onPageChange={handleChangePage}
                                    rowsPerPage={rowsPerPage}
                                    onRowsPerPageChange={handleChangeRowsPerPage}
                                    rowsPerPageOptions={[10, 20, 40, 60, 80, 100]}
                                    labelRowsPerPage="Registros por página"
                                />
                            </TableContainer>

                        </div>
                    </div>
                </Box>

            </Modal>

            <Modal
                open={openPagar} onClose={() => setOpenPagar(false)}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={styleRend}>
                    <div className='nav-header2 pt-4'></div>
                    <div className='card'>
                        <div className='card-header text-center'>
                            <h3>Rendimiento</h3>
                        </div>
                        <div className='card-body'>
                            {/** AGREGAR UNA TRABLA INDEXADA CON LOS CONTRATOS PROXIMOS */}
                            <TableContainer component={Paper}>
                                <Table sx={{ minWidth: 700 }} aria-label="customized table" className="animation-layout">
                                    <TableHead>
                                        <TableRow>
                                            <StyledTableCell>Ahorrado</StyledTableCell>
                                            <StyledTableCell align="center">Rendimiento</StyledTableCell>
                                            <StyledTableCell align="center">Total</StyledTableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                            <StyledTableCell align="center">{sumaAhorro}</StyledTableCell>
                                            <StyledTableCell align="center">{rendimientoAhorro}</StyledTableCell>
                                            <StyledTableCell align="center">{ahorroRendimientoTotal}</StyledTableCell>
                                    </TableBody>
                                </Table>

                            </TableContainer>

                        </div>
                    </div>
                </Box>

            </Modal>


        </>
    )
}

export default ModalContratosProximos